import { useLingui } from "@lingui/react/macro";
import { toast } from "@offstreetparking/design-system/feedback";

export const usePermitSentToast = () => {
	const { t } = useLingui();
	return (emails: string[]) => {
		const [email] = emails;
		const count = emails.length;
		toast({
			role: "status",
			title:
				count === 1 && email
					? t({
							message: `Permit sent to ${email}`,
							comment: "Success toast after a parker emails their permit to one address",
						})
					: t({
							message: `Permit sent to ${count} emails`,
							comment:
								"Success toast after a parker emails their permit to several addresses; count is always 2 or more",
						}),
		});
	};
};
